import NewEmail from './container/index';

export default NewEmail;


// WEBPACK FOOTER //
// ./src/views/email/newEmail/index.js